import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "History of Everything",
  "description": "",
  "published": "2008-11-20T00:00:00.000Z",
  "redirect_from": ["/blog/history-of-everything/swizec/40"],
  "categories": "linkages, video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`History of Everything is a song by The Bare Naked Ladies and has been loved by me for the past two years as the theme song of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/The_big_bang_theory"
      }}>{`The Big Bang Theory`}</a>{`, the best show on earth, but more on that later. This post can only be done justice by your watching the following video.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      